<template>
  <div class="row m-0" v-show="this.$store.state.photo.isMapView">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="col-xl-12 col-lg-12 col-md-12 px-0" id="simple_photo_checkbox">
      <div class="gallery-slider-container">
        <div class="row m-0 reverse-on-m">
          <div class="col-xl-6 col-lg-6 col-md-6 screen-height mt-2 photos-docu"  v-bind:style="isSelecteAble ? 'padding-bottom:70px' : ''">
            <div class="row" id="simple_photo" :class="{ isBottomNav: this.$store.state.photo.isBottomNav }">
              <div v-for="(photo, index) in photos" :key="index" class="col-xl-4 col-lg-4 col-md-4 pl-0">

                <div class="simple-photo"
                     @click="setSliderImages(photo , index, $event)"
                     :photo_id='photo.id'
                     v-on:click.shift="selectMultiple($event, index)"
                     :data-index="index"
                     >
<!--                  <photodetail :imgdata="photo" :isEdit="isEdit" :isMap="true" :index="index"></photodetail>-->
                  <photovirtual :key="'plan-' + photo.pdphotoid" :instance-id="'plan-' + photo.pdphotoid" :imgdata="photo" :index="index" :isEdit="isEdit" :isMap="true" v-if="photo.phototype === '360'"></photovirtual>
                  <photodetail :key="'plan-' + photo.pdphotoid" :instance-id="'plan-' + photo.pdphotoid" :imgdata="photo" :index="index" :isEdit="isEdit" :isMap="true" v-else></photodetail>
                </div>
              </div>
            </div>

            <div class="row shadow-sm border  pl-0 position-sticky bg-white border-top pt-1 text-center pagination"  v-if="$store.state.photo.TPage > '1'" style="bottom: 0">
              <div class="col-md-3 text-left pr-0 pt-1 pb-2">
                <span class="font13" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>
                <span class="font13" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>
              </div>
              <div class="col-md-6 main-photos-pagination pb-2">
                <sliding-pagination :current="pagingCurrentPage"
                                    :total="pagingTotalPages"
                                    @page-change="pageChangeHandler"
                                    :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link"
             }' />

              </div>
            </div>
          </div>
<!--          Canvas Component-->

            <photos-canvas/>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Popup from './infoPopup'
import SlidingPagination from 'vue-sliding-pagination'
import PhotosCanvas from './PhotosCanvas'
import photodetail from './subitems/photodetail'
import {mapState} from 'vuex'
import Photovirtual from './subitems/photovirtual.vue'

export default {
  name: 'WithMap',
  components: {
    Photovirtual,
    Popup, SlidingPagination, PhotosCanvas, photodetail
  },
  data () {
    return  {
      photo_id : '',
      drag_photo : '',
      allow_drop : '',
      dragImg: '',

    }
  },
  created() {
    let img = new Image()
    img.width = '10px';
    img.height = '10px';
    img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVElEQVQ4jaWUMW7CQBBFZ6cAR4gC0YRIKblCOg6AyCUsQUHjA1BQUHAAGgqQfIkgDkCXK6RECjRRCsuCpGCjT7Bl785iZH6zknfn7Yzn7yitNUn6fVvrwzKk0+eOTrt9eqLy2qVqr4tVSXEWEKB4Ms1BXKrPZxY4B4wnU31chIWgrLyBT7XxKIXyPTAIMYjNAVFmGVgWCgYlJX89t8XOoAH1+SwtB0E/qzVW6yy3HqnxvlGckE3VxqMc7HKBwjfsmUITwWLcKGXmDXzRFvTfCIUzpmAzltKHz4pkZg/BsyzFuUxbJJQtAu8Roztl5Gom81PL+hgNA/mBZ+RqJj/0fWsDjTouQicUe65mno39/dLR0jCQJguyl2BQc/uhzkD8j2gYFFV5Vcnk4UsmClOjrBCbVJHaBiOoDNQcX+KAvaV82A1v+uqANcHmZAEENoMzxNdERH/4z7yuLBq+4wAAAABJRU5ErkJggg=='
    this.dragImg = img
  },
  mounted () {

    // $('.draggableimage').bind('dragstart', function(event) {
    //   console.log('Draging!')
    //   event.dataTransfer.setDragImage(document.getElementById('div_drag'),50,50);
    // })
//
    console.log('WhitMap Mounted!!!')

$('.draggableimage').on('dragstart', function(e) {

  console.log('Element', this)
    // var img = new Image();
    // img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVElEQVQ4jaWUMW7CQBBFZ6cAR4gC0YRIKblCOg6AyCUsQUHjA1BQUHAAGgqQfIkgDkCXK6RECjRRCsuCpGCjT7Bl785iZH6zknfn7Yzn7yitNUn6fVvrwzKk0+eOTrt9eqLy2qVqr4tVSXEWEKB4Ms1BXKrPZxY4B4wnU31chIWgrLyBT7XxKIXyPTAIMYjNAVFmGVgWCgYlJX89t8XOoAH1+SwtB0E/qzVW6yy3HqnxvlGckE3VxqMc7HKBwjfsmUITwWLcKGXmDXzRFvTfCIUzpmAzltKHz4pkZg/BsyzFuUxbJJQtAu8Roztl5Gom81PL+hgNA/mBZ+RqJj/0fWsDjTouQicUe65mno39/dLR0jCQJguyl2BQc/uhzkD8j2gYFFV5Vcnk4UsmClOjrBCbVJHaBiOoDNQcX+KAvaV82A1v+uqANcHmZAEENoMzxNdERH/4z7yuLBq+4wAAAABJRU5ErkJggg==';
    // img.width = '10px';
    // img.height = '10px';
    // e.originalEvent.dataTransfer.setDragImage(img, 10, 10);
  });

  },

  computed: {
    photos () {
      return this.$store.state.photo.canvasPhotos
    },
    creators () {
      return this.$store.state.creators
    },

    pagingTotalPages () {
      return this.$store.state.photo.TPage
    },
    pagingCurrentPage () {
      return this.$store.state.photo.page
    },


    isSelecteAble: {
      get () {
        return this.$store.state.photo.isBottomNav
      }
    },
    selectedImages: {
      get () {
        if (this.isSelecteAble) {
          return this.$store.state.photo.selectedPhotos
        } else {
          return this.$store.state.photo.detailsSelectedImages
        }
      },
      set (val) {
        if (this.isSelecteAble) {
          this.$store.commit('setSelectedPhotos', val)
        } else {
          this.$store.commit('setDetailsSelectedImages', val)
        }
      }
    },

    detailsSelectedImages: {
      get () {
        if (this.isSelecteAble) {
          return this.$store.state.photo.selectedPhotos
        } else {
          return this.$store.state.photo.detailsSelectedImages
        }
      },
      set (val) {
        if (this.isSelecteAble) {
          this.$store.commit('setSelectedPhotos', val)
        } else {
          this.$store.commit('setDetailsSelectedImages', val)
        }
      }
    },
    // isSelecteAble () {
    //   return this.$store.state.photo.isBottomNav
    // },
    isEdit(){
      return this.$store.state.photo.isEdit;
    },


  },

  methods: {

    setSliderImages (imgId, index = null, event = null) {

      console.log('Event', event)
      if (!this.isSelecteAble) {
        let payload = { id: this.$route.params.id, img_id: imgId.pdphotoid }
        this.$store.dispatch('getImageDetails', payload)

        this.currentImage = index || this.currentImage
        this.is_slider_set = true
        this.$store.commit('setActiveImage', imgId)
      }
    },

    selectMultiple (event, last) {
      let obj = this
      if (this.isSelecteAble) {
        let start = this.lastimageindex
        let index = event.target.getAttribute('data-index')
        index = last
        for (let i = start; i < index; i++) {
          if (obj.selectedImages.findIndex((item) => item.pdphotoid === obj.photos[i].pdphotoid) < 0) {
            obj.selectedImages.push(obj.photos[i])
          }
        }
      }
    },



    // Pagination
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },
    // START XXL VIEW
    showModal (photoXXL, photosXXL) {
      console.log('showModal in WithMap.vue')
      this.$parent.loadXXL(photoXXL)
    },

    allocateByGPS(photo, event) {
      let _this = this

      console.log('allocateByGPS(photo, event)')

      if(!this.usercan('editor')) {
        return false
      }

      console.log('allocateByGPS(photo, event) - RUN RUN RUN')

      console.log('Vue-Confirm-Dialog')
      this.$confirm({
        title: 'GPS Planverortung',
        message: 'Möchten Sie das Foto anhand der GPS-Daten auf dem Plan verorten?',
        button: {
          no: 'Nein',
          yes: 'Ja'
        },
        callback: confirm => {
          console.log('Confirm', confirm)
          if(confirm) {
            console.log('AllocateByGPS', photo, event)
            _this.$store.state.photo.flagbygps = photo
          }
        }
      })


    },
    allocatePreviewByGPS(photo, event) {
        console.log('AllocatePreviewByGPS WithMap', photo, event)
        this.$store.state.photo.flagpreviewbygps = photo
    },
    removePreviewByGPS() {
      this.$store.state.photo.flagpreviewbygps = false
    },

    setDropPhotoId(photo,event){
      console.log('DragStart setDropPhotoId', event)
      // let srcelement = event.srcElement
      //
      //
      // console.log('DragPhoto', event)
      this.photo_id = photo.pdphotoid;
      this.drag_photo = photo;

      event.dataTransfer.setDragImage(this.dragImg, 10, 10);
    },
    imagehover(photo, $event) {
      this.$store.commit('setflashHighlight', photo)
    },
    imageHoverStop(photo, $event) {
      this.$store.commit('setflashHighlight', false)
    }

  },
  watch: {
    '$store.state.photo.canvasplan': function(v) {
      // Fix change plan if current photolist page is not 1!!!
      this.$store.state.photo.page = 1
      this.$root.$emit('pageChangeHandler', 1)
    },
    // '': function(v) {
    //   this.$store.state.photo.page = 1
    //   this.$root.$emit('pageChangeHandler', 1)
    // }
  }
}




</script>
<style scoped>
.reverse-on-m{
  /*min-height: 100% !important;*/
}



</style>



// WEBPACK FOOTER //
// src/components/photo/components/WithMap.vue